import ModalIconButtonTriggerExample from "../../../../../../packages/design-system/entry-points/examples/constellation/modal-icon-button-trigger";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_icon_button_trigger from "!!raw-loader!../../../../../../packages/design-system/entry-points/examples/constellation/modal-icon-button-trigger";
import * as React from 'react';
export default {
  ModalIconButtonTriggerExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_icon_button_trigger,
  React
};